import { getUserTaxonomy } from '../getUserTaxonomy/getUserTaxonomy';
import { getABTests } from '../getABTests/getABTests';
import { ApolloClient } from '@apollo/client';
import snakeCase from 'lodash/snakeCase';
import { BaseTaxonomy } from '../contracts';

export const ANALYTICS_BASE_TAXONOMY = {
    countryCode: 'gb',
    platform: 'React',
    brandPrimary: 'zoopla',
    brand: 'zoopla'
} as Partial<BaseTaxonomy> as BaseTaxonomy;

export const snakeCaseKeys = <T extends Record<string, unknown>>(obj: T) =>
    Object.entries(obj).reduce<T>(
        (acc, [key, value]) => ({
            ...acc,
            ...{ [snakeCase(key)]: value }
        }),
        {} as T
    );

const removePropertiesWithNullValues = <T extends Record<string, unknown>>(
    obj: T
) =>
    Object.entries(obj).reduce<T>(
        (acc, [key, value]) => ({
            ...acc,
            ...(value !== null && value !== undefined && { [key]: value })
        }),
        {} as T
    );

export const getPageTrackingData = async (
    page: string,
    extraTaxonomy: Record<string, unknown> = {},
    extraEcommerce: Record<string, unknown> | null = null,
    client?: ApolloClient<unknown>
) => {
    const baseTaxonomy = {
        ...ANALYTICS_BASE_TAXONOMY,
        page
    };

    const [userTaxonomy, abTests] = await Promise.all([
        getUserTaxonomy(client),
        getABTests(client)
    ]);

    const taxonomy = snakeCaseKeys(
        removePropertiesWithNullValues({
            ...baseTaxonomy,
            ...userTaxonomy,
            ...extraTaxonomy
        })
    );

    const ecommerce = snakeCaseKeys(
        removePropertiesWithNullValues({
            ...extraEcommerce
        })
    );

    return {
        taxonomy,
        ...(extraEcommerce && { ecommerce }),
        ...(abTests && { ab: abTests })
    };
};
